<script setup lang="ts">
import type { ComposedMetaData } from '@xcel-next/composer-schema'

defineProps<{
  printUsage: ComposedMetaData['printUsage']
}>()
</script>

<template>
  <div class="bx-content bx-content__print-usage">
    Aus <strong>{{ printUsage?.brand }}</strong> {{ printUsage?.issue }}/{{ printUsage?.year }}
  </div>
</template>
